module.exports = __webpack_public_path__ + "img/barrera.516c0431.png";